// Thin client for RevQ-owned alerts-enrollment routes (NOT under /api/proxy).
import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/alerts`;

function authHeader() {
  const t = sessionStorage.getItem("revq.token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export const ALERT_CATEGORIES = [
  { key: "application", label: "Application processing updates", desc: "New-user / sub-login applications and identity-verification outcomes" },
  { key: "batch", label: "Batch job updates", desc: "EDI 837 batches and claim-scrubber runs finishing or failing" },
  { key: "billing", label: "Billing & credits", desc: "Invoices, low credit balance and charges" },
  { key: "claims", label: "Claim status changes", desc: "Claims accepted, rejected or paid" },
  { key: "remittance", label: "Remittance / EOB posted", desc: "835s and payments posted to the check ledger" },
  { key: "eligibility", label: "Eligibility & intake", desc: "Eligibility results and patient intake updates" },
  { key: "security", label: "Security & sign-in alerts", desc: "New-device sign-ins and password changes" },
  { key: "product", label: "Product news & maintenance", desc: "Releases and scheduled downtime" },
];

export const getEnrollment = () => axios.get(`${BASE}/enrollment`, { headers: authHeader() }).then((r) => r.data);
export const startEnrollment = () => axios.post(`${BASE}/enrollment/start`, {}, { headers: authHeader() }).then((r) => r.data);
export const verifyEnrollment = (otp, categories) => axios.post(`${BASE}/enrollment/verify`, { otp, categories }, { headers: authHeader() }).then((r) => r.data);
export const dismissEnrollment = () => axios.post(`${BASE}/enrollment/dismiss`, {}, { headers: authHeader() }).then((r) => r.data);
export const sendInvite = (payload) => axios.post(`${BASE}/invite`, payload, { headers: authHeader() }).then((r) => r.data);
